import styled from "styled-components";

export const Container = styled.div`
  width: 95%;
  margin: 0 auto;
  background: #ffffff;

  @media (min-width: 1600px) {
    max-width: 1520px;
  }

  @media (min-width: 1360px) and (max-width: 1600px) {
    max-width: 1320px;
  }

  @media (max-width: 1360px) {
    max-width: 1100px;
  }
`;

export const SearchBarBox = styled.div`
  width: 80%;
  margin: auto;
  display: flex;
  flex-direction: row;
  margin-bottom: 12px;
  justify-content: center;
`;

export const PeriodContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 12px;
  justify-content: center;

  fieldset {
    margin-right: 16px;
  }

  label {
    margin-right: 5px;
  }
`;

export const SearchInput = styled.input`
  width: 85%;
  padding: 8px;
  font-size: 14px;
`;

export const SearchButton = styled.button`
  width: 12.5%;
  padding: 8px 6px;
  margin: 0 4px;
  font-size: 16px;
`;

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 90%;
  margin: auto;
  border: solid 1px #ccc;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 13.666%);
  font-weight: 500;
  width: 100%;
  margin: auto;
  justify-content: center;
  align-items: center;
`;

export const TableBody = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 13.666%);
  width: 100%;
  margin: auto;
  justify-content: center;
  align-items: center;
`;

export const Item = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: center;
  text-align: center;
`;

export const ChartBox = styled.div`
  width: 90%;
  margin: auto;
  border: solid 2px #ccc;
  padding: 0.7rem 0.5rem;
  display: flex;
  flex-direction: column;
  margin: 1rem auto;
`;

export const ChartBarsBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: flex-end;
  height: 12rem;
  border: solid 1px #ddd;

  & > div {
    width: 15.6666%;
    justify-content: center;
  }
`;

export const BarBox = styled.div`
  height: 12rem;
  position: relative;
  display: flex;
  justify-content: center;
`;

export const Bar = styled.div`
  background: ${(props) => (props.percent == 0 ? "#fff" : "#ff7417")};
  border: ${(props) => (props.percent == 0 ? "none" : "solid 1px #ff7417")};
  color: #000;
  padding-bottom: ${(props) => (props.percent == 0 ? "0.5rem" : "0")};
  height: ${(props) => `${props.percent}%`};
  width: 4.5rem;
  margin: auto;
  text-align: center;
  justify-items: center;
  font-weight: 600;
  text-decoration: underline;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  transition: var(--transition);
  animation: load 2s forwards;
  overflow: visible;

  :hover {
    filter: brightness(1.15);
    transition: var(--transition);
  }
`;
export const ChartX = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: baseline;

  & > div {
    width: 15.6666%;
  }
`;

export const Message = styled.div`
  width: 90%;
  border: solid 1px #111;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  padding: 2rem;
  margin: auto;
`;

export const ValidateExhibition = styled.div`
  display: flex;
  flex-direction: column;
  width: 95%;
  margin: auto;
`;

export const Top = styled.div`
  border: solid 1px #ccc;
`;

export const TableValidate = styled.div`
  display: flex;
  flex-direction: column;
  border: solid 1px #ccc;
  margin-top: 0.5rem;
`;

export const ValidateHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 33.333%);
  text-align: center;
`;

export const ValidateBody = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 33.333%);
  text-align: center;
  border-bottom: solid 1px #ccc;

  :hover {
    background: #ddd;
  }
`;
